import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export type ListItemsIconWithoutBorderProps = {
  size?: number | string
  fillColor?: string
}

export const ListItemsIconWithoutBorder: FunctionComponent<ListItemsIconWithoutBorderProps> = ({
  size = 24,
  fillColor,
}) => {
  const { colors } = useTheme()
  const fill = fillColor || colors.iconDefault

  return (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' accessible={false}>
      <Path
        d='M4 13C4.55 13 5 12.55 5 12C5 11.45 4.55 11 4 11C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13Z'
        fill={fill}
      />
      <Path
        d='M4 17C4.55 17 5 16.55 5 16C5 15.45 4.55 15 4 15C3.45 15 3 15.45 3 16C3 16.55 3.45 17 4 17Z'
        fill={fill}
      />
      <Path d='M4 9C4.55 9 5 8.55 5 8C5 7.45 4.55 7 4 7C3.45 7 3 7.45 3 8C3 8.55 3.45 9 4 9Z' fill={fill} />
      <Path
        d='M8 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H8C7.45 11 7 11.45 7 12C7 12.55 7.45 13 8 13Z'
        fill={fill}
      />
      <Path
        d='M8 17H20C20.55 17 21 16.55 21 16C21 15.45 20.55 15 20 15H8C7.45 15 7 15.45 7 16C7 16.55 7.45 17 8 17Z'
        fill={fill}
      />
      <Path d='M7 8C7 8.55 7.45 9 8 9H20C20.55 9 21 8.55 21 8C21 7.45 20.55 7 20 7H8C7.45 7 7 7.45 7 8Z' fill={fill} />
    </Svg>
  )
}
